import { render, staticRenderFns } from "./SemiDonutMulti.vue?vue&type=template&id=51d6e5a0&scoped=true&"
import script from "./SemiDonutMulti.vue?vue&type=script&lang=js&"
export * from "./SemiDonutMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d6e5a0",
  null
  
)

export default component.exports